<style lang="less">
    .page_con.combo{
        width:100vw;
        height:100vh;
        overflow: hidden;
        background:url("../assets/images/bg3.png") no-repeat;
        background-size: 100% 100%;
        .top_con{
            width:100%;
            height:11vh;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            background:url("../assets/images/topbar-3.png") no-repeat;
            background-size: 100% 100%;
            img{
                width:.6rem;
                height:auto;
                display: block;
            }
            p{
                font-size: .4rem;
                color:#fff;
                font-weight: bold;
                margin-left:.1rem;
                letter-spacing: .05rem;
            }
        }
        .content_con{
            width:100%;
            // height:79vh;
            margin-top:9vh;
            padding:0 2.5vw;
            .room{
                width:95vw;
                height:95vw;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .row{
                    width:100%;
                    flex:1;
                    margin-bottom:1vw;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    >div{
                        flex:1;
                        margin-right:1%;
                        height:100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background:#bbb;
                        color:#bbb;
                        border-radius: .1rem;
                        font-size: calc(100% + 3px);
                        border:.01rem solid transparent;
                    }
                    >div:last-child{
                        margin-right:0;
                    }
                    >div.active{
                        background:#fff;
                        color:#333;
                        border-color:#bbb;
                    }
                }
            }
            .opts{
                width:100%;
                height:15vw;
                margin-top:3vh;
                display: flex;
                align-items: center;
                justify-content: space-between;
                >div{
                    width:15vw;
                    height:15vw;
                    line-height:15vw;
                    background: linear-gradient(30deg, #29AF35, #CEDB00 65%);
                    color:#333;
                    border-radius: .1rem;
                    text-align: center;
                    font-size: .6rem;
                    box-shadow: 0.02rem 0.02rem 0.05rem 0 rgba(0, 0, 0, 0.5);
                }
            }
            .pasue{
                width:100%;
                height:89vh;
                display: flex;
                align-items: center;
                justify-content: center;
                .pasue_con{
                    width:70%;
                    margin-bottom: 20vh;
                    position: relative;
                    .bg{
                        width:100%;
                        height:auto;
                        display: block;
                    }
                    .tt,.next,.goon{
                        height:auto;
                        display: block;
                        position: absolute;
                        left:50%;
                        z-index: 11;
                        transform: translateX(-50%);
                    }
                    .tt{
                        width:100%;
                        top:0;
                    }
                    .next{
                        width:80%;
                        top:30%;
                    }
                    .goon{
                        width:80%;
                        top:60%;
                    }
                }
            }
        }
        .btns{
            width:100%;
            height:10vh;
            // position: fixed;
            bottom: 0;
            left: 0;
            z-index: 11;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img{
                width:25vw;
                height:auto;
                display: block;
            }
        }
    }
</style>
<template>
    <div class="page_con combo">
        <div class="top_con">
            <img src="../assets/images/time.png" alt="">
            <interval :time="time" ref="time" :pause="pauseStatus" @change="pauseTimer"></interval>
        </div>
        <!-- <div class="quest_num">
            <img src="../assets/images/grade-button.png" alt="">
            <p>第112題</p>
        </div> -->
        <div class="content_con">
            <div class="room" v-show="!pauseStatus">
                <div class="row" v-for="(item,index) in arr" :key="index">
                    <div v-for="(text,idx) in item" :key="idx" :class="[text.show?'active':'']" :style="'font-size:calc(50vw / '+ item.length">{{text?text.text:''}}</div>
                </div>
            </div>
            <div class="opts" v-show="!pauseStatus">
                <div v-for="(item,index) in opts[current-1]" :key="index" @click="choice(item)">{{item}}</div>
            </div>
            <div class="pasue" v-show="pauseStatus">
                <div class="pasue_con">
                    <img class="tt" src="../assets/images/button-pause.png" alt="">
                    <img class="bg" src="../assets/images/bg-game3.png" alt="">
                    <img class="next" @click="pauseClick" src="../assets/images/next-game3.png" alt="">
                    <img class="goon" @click="reset" src="../assets/images/start-again.png" alt="">
                </div>
            </div>
        </div>
        <div class="btns" v-show="!pauseStatus">
            <img src="../assets/images/back-button.png" @click="$router.go(-1)" alt="">
            <img src="../assets/images/pause-button.png" @click="pauseClick" alt="">
        </div>
        
        <div class="shade" v-if="tips_bag || toast != 'none'">
            <div class="tips_bag" v-if="tips_bag">
                <img src="../assets/images/tip-bg.png" alt="">
                <img class="close" src="../assets/images/close-tipbutton.png" alt="" @click="tips_bag='close'">
                
                <p v-if="tips" v-html="tips"></p>
                <p v-else style="text-align:center;" v-html="'今天沒有學習錦囊'"></p>
            </div>


            <div class="toast" v-if="toast != 'none'">
                <div v-if="toast == 'success'" class="toast_success">
                    <template v-if="isEnd">
                        <img class="result" src="../assets/images/DONE-answer.png" alt="">
                        <img src="../assets/images/backhome.png" alt="" class="goon" @click="answerEnd">
                    </template>
                    <template v-else>
                        <img class="result" src="../assets/images/yes-answer.png" alt="">
                        <img src="../assets/images/next.png" alt="" class="goon" @click="next">
                    </template>
                </div>
                <div v-if="toast == 'error'" class="toast_error">
                    <img class="result" src="../assets/images/NO-answer.png" alt="">
                    <img src="../assets/images/continue.png" alt="" class="goon" @click="goon">
                </div>
            </div>
        </div>
        <div class="shade tips_result" v-if="tips_bag == 'close'">
            <div class="tips_result">
                <img class="readed" src="../assets/images/read-done.png" alt="">
                <img class="close" @click="tips_bag=false" src="../assets/images/certain-button.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import interval from './timer';
export default {
    components:{
        interval
    },
    data(){
        return {
            pauseStatus:false,  //暫停狀態
            time:300,    //倒計時
            
            setsIndex:0,        //当前第几套题
            isEnd:false,        //是否结束
            is_right:1,         //是否全对
            
            tips_bag:'',
            toast:'none',
            tips_time:0,        //锦囊使用次数
            tips:'',

            // pasue:false,
            current:1,
            max:{x:0,y:0},
            arr:[
                // [{text:'信',show:1,index:0},{text:'徒',show:0,index:1},'','','',''],
                // ['',{text:'步',show:0,index:2},{text:'行',show:0,index:3},'','',''],
                // ['','',{text:'政',show:0,index:4},{text:'績',show:0,index:5},'',''],
                // ['','','',{text:'效',show:0,index:6},{text:'忠',show:0,index:7},''],
                // ['','','','',{text:'誠',show:0,index:8},{text:'意',show:0,index:9}],
                // ['','','','','',{text:'圖',show:0,index:10}],
            ],
            opts:[
                // ['人','信','餓','的','我','個'],
                // ['一','飛','徒','嗎','他','肉'],
                // ['人','就','餓','平','步','個'],
                // ['行','就','也','的','找','為'],
                // ['人','請','餓','的','我','政'],
                // ['人','就','卡','績','是','在'],
                // ['一','效','才','嗎','我','肉'],
                // ['人','就','餓','平','的','忠'],
                // ['人','就','誠','的','找','為'],
                // ['意','請','餓','的','我','個'],
                // ['人','就','卡','看','圖','在'],
            ],
        }
    },
    mounted() {
        let query = this.$route.query;
        this.getData(query.date);
    },
    methods: {
        answerEnd(){
            this.updateData(this.getTime(),this.tips_time,this.is_right,this.$route.query.date);
        },
        choice(item){
            let index = this.getIndex(this.current);
            let cur = this.arr[index.y][index.x];
            console.log(cur,index);
            if(cur && item == cur.text){
                cur.show = 1;
                console.log();
                this.current += 1;
                if(cur.x >= this.max.x && cur.y >= this.max.y){
                    console.log('答完了');
                    if(!this.hasMore()){
                        this.isEnd=true;
                    }
                    this.toast = 'success';
                }else{
                    console.log('還有');
                    // this.$router.push('/index');
                }
            }else{
                console.log('答錯了');
                this.toast = 'error';
            }
        },
        goon(){
            this.toast = 'none';
        },
        hasMore(){
            let setsIndex = this.setsIndex + 1;
            if(this.$store.getters.gameData[setsIndex]){
                return true;
            }else{
                return false;
            }
        },
        next(){
            // let setsIndex = this.setsIndex + 1;
            this.setsIndex += 1;
            // if(this.hasMore()){
                this.init(this.setsIndex);
                this.reset();
            // }else{
                // this.isEnd = true;
                // this.toast = 'success';
            // }
        },
        getTime(){
            return this.time - this.$refs.time.getTime();
        },
        getIndex(n){
            let x=0,y=0;
            for(let i=0;i<n;i++){
                if(i%2 == 0){
                    x+=1;
                }else{
                    y+=1;
                }
            }
            return {x:x,y:y}
        },
        getData(date){
            let vm = this;
            vm.$http.get('/GameDaily/index?type=9&rest_key=1'+(date?('&pushdate='+date):'')).then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    vm.$store.commit('setGameData',res.data.data.game);
                    vm.init(vm.setsIndex);
                }
            })
        },
        init(sets){
            // let arr = ['信','徒','步','行','政','績','效','忠','誠','意','圖'];
            let data = JSON.parse(JSON.stringify(this.$store.getters.gameData[sets])); 
            this.oldTime = 300;
            this.opts = data.options.map(v=>{
                v = this.randomIndex(v);
                return v;
            });
            console.log(this.opts);
            let arr = data.words;
            let index = 0;
            let all = [];
            let num = (data.words.length+1)/2;
            for(let i=0;i<num;i++){
                let row = [];
                for(let k=0;k<num;k++){
                    let indexs = this.getIndex(index);
                    if(indexs.x == k){
                        // row[k] = {text:arr[index],show:0,x:k,y:i};
                        row.push({text:arr[index],show:0,x:k,y:i});
                        index += 1;
                    }else{
                        row.push('');
                    }
                }
                all.push(row);
            }
            data.words.shift();
            this.max = this.getIndex(data.words.length);
            console.log(all);
            all[0][0].show = 1;
            this.arr = all;
        },
        reset(){
            this.pauseStatus = false;
            this.current = 1;
            this.time = this.oldTime;
            this.toast = 'none';
            this.tips_bag = '';
            this.init(this.setsIndex);
        },
        pauseClick(){
            this.pauseStatus = !this.pauseStatus;
        },
        pauseTimer(time){
            // this.pauseStatus = !this.pauseStatus;
            console.log(time);
            this.time = time;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/combo.vue